<template>
  <div class="title-buy">
    <div class="title-buy__title">Conviértete en el aficionado más inteligente</div>
    <div class="title-buy__title-mobile">Conviértete en el <br />aficionado más inteligente</div>
    <div class="title-buy__subtitle">Revive videos de las jugadas más históricas.</div>
  </div>
</template>
<script>
export default {
  name: 'Title',
  components: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {},
  created() {},
  mounted() {},
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
.title-buy {
  width: 100%;
  height: auto;
  &__title-mobile {
    display: none;
    width: 100%;
    height: auto;
    font-family: 'Avenir-Demi';
    font-size: 47px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: -0.94px;
    text-align: center;
    color: #fff;
    @media screen and (max-width: 580px) {
      display: inline-block;
      font-size: 36px;
      line-height: 36px;
    }
    @media screen and (max-width: 480px) {
      display: inline-block;
      font-size: 30px;
      line-height: 32px;
    }
    @media screen and (max-width: 380px) {
      font-size: 26px;
      line-height: 32px;
    }
    @media screen and (max-width: 340px) {
      font-size: 24px;
      line-height: 27px;
    }
  }
  &__title {
    width: 100%;
    height: auto;
    font-family: 'Avenir-Demi';
    font-size: 47px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: -0.94px;
    text-align: center;
    color: #fff;
    @media screen and (max-width: 1095px) {
      font-size: 42px;
    }
    @media screen and (max-width: 935px) {
      font-size: 35px;
      margin-top: 15px;
    }
    @media screen and (max-width: 835px) {
      font-size: 30px;
      margin-top: 10px;
    }
    @media screen and (max-width: 700px) {
      font-size: 28px;
      margin-top: 10px;
    }
    @media screen and (max-width: 580px) {
      display: none;
    }
  }
  &__subtitle {
    width: 100%;
    height: auto;
    font-family: 'Avenir-Regular';
    font-size: 27px;
    font-weight: 300;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    margin-top: 5px;
    letter-spacing: normal;
    text-align: center;
    color: #fff;
    @media screen and (max-width: 1095px) {
      font-size: 22px;
      margin-top: 15px;
    }
    @media screen and (max-width: 935px) {
      font-size: 18px;
      margin-top: 15px;
    }
    @media screen and (max-width: 835px) {
      font-size: 16px;
      margin-top: 8px;
    }
    @media screen and (max-width: 700px) {
      font-size: 15px;
      margin-top: 8px;
    }
    @media screen and (max-width: 580px) {
      display: none;
    }
  }
}
</style>
